import React, { Fragment, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Header from "./components/layout/Header";
// import Footer from "./components/layout/Footer";
import HomePage from "./components/layout/HomePage";

import RoutesFile from "./components/routing/RoutesFile";

// Redux
import { Provider } from "react-redux";
import store from "./store";
import { loadUser } from "./actions/auth";
import setAuthToken from "./utils/setAuthToken";
import LandingPage from "./components/landing/LandingPage";
//import './App.css';
import "./styles/bootstrap/css/bootstrap.min.css";
import "./styles/CustomisedStyle.css";

import Login from "./components/auth/Login";
import PrivacyPolicy from "./components/landing/PrivacyPolicy";
import TermsConditions from "./components/landing/TermsConditions";
import SampadaProducts from "./components/SampadaProducts";
// import Alert from "./components/layout/Alert";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Fragment>
          <div className="row">
            {/* <div className="col-lg-2 col-md-2 col-sm-12 col-12 no_padding">
              <Header />
            </div> */}
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 no_padding">
              <Switch>
                <Route exact path="/" component={LandingPage} />
                <Route exact path="/privacy-policy" component={PrivacyPolicy} />
                <Route
                  exact
                  path="/terms-conditions"
                  component={TermsConditions}
                />
                {/* <Route
                  exact
                  path="/sampada-product-details"
                  component={SampadaProducts}
                /> */}
                <Route exact path="/Login" component={HomePage} />
                <Route exact path="/login" component={Login} />
                <Route component={RoutesFile} />
              </Switch>
            </div>
          </div>
        </Fragment>
      </Router>
    </Provider>
  );
};

export default App;
